module.exports = __webpack_public_path__ + "static/media/CreateDataSet.ea453101.svg";